module.exports = __webpack_public_path__ + "media/images/search-6988473aebc41bd4413641c09123e39c.svg";